import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[searchSelectItem]'
})
export class SearchSelectItemDirective {
    @Input() approxHeight: number;
    @Input() approxWidth: number;

    constructor(readonly templateRef: TemplateRef<any>) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/directives/search-select-item.directive.ts